import React from 'react';

export default function InlineToggle({ value, onChange, size=16, disabled=false }) {
  const active = !!value;
  const handleChange = () => {
    if (disabled) return;
    if (typeof onChange === 'function') onChange(!active);
  };

  // Note: `size` kept for backward compatibility; Settings-style switch uses CSS sizing.
  return (
    <label className={`switch${disabled ? ' disabled' : ''}`}>
      <input
        type="checkbox"
        checked={active}
        onChange={handleChange}
        disabled={disabled}
        aria-checked={active}
      />
      <span className="slider round" />
    </label>
  );
}
